import { TFunction } from "react-i18next";
import { QuestionnaireTableRow } from "../../../core/types";

export const getQuestionnaireStatus = (
  patientQuestionnaireAnswersAndRequests: QuestionnaireTableRow[] | undefined,
  t: TFunction<"translation", undefined>,
):
  | {
      variant: "hidden" | "STATUS_ORANGE" | "transparent";
      text: string;
      intent: "NO_QUESTIONNAIRES" | "NEW_RESPONSE" | "PENDING";
    }
  | undefined => {
  if (!patientQuestionnaireAnswersAndRequests) {
    return {
      variant: "hidden",
      text: t("NO_QUESTIONNAIRES"),
      intent: "NO_QUESTIONNAIRES",
    };
  }
  if (patientQuestionnaireAnswersAndRequests.length === 0) {
    return {
      variant: "hidden",
      text: t("NO_QUESTIONNAIRES"),
      intent: "NO_QUESTIONNAIRES",
    };
  }

  const newResponses = patientQuestionnaireAnswersAndRequests.some(
    (answer) => answer.isNew,
  );
  if (newResponses) {
    return {
      variant: "STATUS_ORANGE",
      text: t("NEW_RESPONSE"),
      intent: "NEW_RESPONSE",
    };
  }

  const pendingResponses = patientQuestionnaireAnswersAndRequests.some(
    (answer) => {
      if (!answer.dateCompleted) {
        return true;
      }
      if (Number.isNaN(new Date(answer.dateCompleted).getTime())) {
        return true;
      }
      return false;
    },
  );

  if (pendingResponses) {
    return {
      variant: "transparent",
      text: t("PENDING_RESPONSE"),
      intent: "PENDING",
    };
  }
};
